module.exports = __webpack_public_path__ + "static/media/evilmorty.0657e1f4.png";